<div class="cb-overview">
  <oph-back-button class="mobile-back-button" (buttonClick)="onBack()" />
  <div class="project-nav">
    <div class="project-nav-back">
      <oph-back-button (buttonClick)="onBack()" />
      <div class="goal-text">{{ selectedGoal() }}</div>
    </div>
    <div class="nav-buttons">
      @if (isActive()) {
        <oph-button
          class="nav-button"
          color="red"
          size="medium"
          [style]="{width: '180px', maxWidth: '180px', height: '38px'}"
          [loading]="stopChallengeLoading()"
          (buttonClick)="onStopChallenge()"
        >
          Stop Challenge
        </oph-button>
      } @else {
        <oph-button
          class="nav-button"
          color="green"
          size="medium"
          [style]="{width: '100%', maxWidth: '100%', height: '38px'}"
          (buttonClick)="onStartChallenge()"
        >
          Start Challenge
        </oph-button>
      }
      <oph-button
        class="nav-button"
        color="orange"
        size="medium"
        [style]="{width: '100%', maxWidth: '100%', height: '38px'}"
        [disabled]="isActive()"
        (buttonClick)="onEditChallenge()"
      >
        <img src="assets/img/icons/pencil-light.svg" alt="Edit" class="icon" />
        Edit Challenge
      </oph-button>
    </div>
  </div>

  <div class="section-card">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/goal.png" alt="Goal" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Infinite Goal</div>
          <div class="section-description">
            Your aspirational direction. It's not a finish line—it's the "infinite game."
          </div>
        </div>
      </div>
    </div>
    <div class="section-content goal-content">
      <div class="section-value">{{ selectedGoal() }}</div>
      <div class="section-cycle">
        <span class="cycle-label">Repeat cycle</span>
        <div class="cycle-days-container">
          <span class="cycle-days">
            <span class="cycle-text-desktop">{{ cbProject()?.challengeBuilder.cycleLength ?? 7 }} days</span>
            <span class="cycle-text-mobile">{{ cbProject()?.challengeBuilder.cycleLength ?? 7 }}-day cycle</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="section-card">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/objectives.png" alt="Objectives" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Objectives</div>
          <div class="section-description">The broad, directional goals that move you toward your infinite goal.</div>
        </div>
      </div>
    </div>
    <div class="section-content">
      <div class="section-list">
        @for (objective of selectedObjectives(); track objective.name) {
          <div class="section-item">{{ objective.name }}</div>
        }
      </div>
    </div>
  </div>

  <!-- Tasks / Metrics / Targets Row -->
  <div class="section-card section-row">
    <div class="section-row-scroll-container">
      <div class="section-row-content">
        <!-- Tasks Column -->
        <div class="section-column">
          <div class="section-header">
            <div class="section-header-content">
              <img src="assets/img/icons/challenge-builder/tasks.png" alt="Tasks" class="section-icon" />
              <div class="section-header-text">
                <div class="section-title">Tasks</div>
                <div class="section-description">The tasks to start (or stop) in order to achieve objectives.</div>
              </div>
            </div>
          </div>
          <div class="column-list tasks-list">
            @for (row of taskMetricRows(); track $index) {
              <div class="column-item task-item" [class.short-item]="!row.showTaskName">
                @if (row.showTaskName) {
                  <cb-task-icon-button
                    [icon]="row.taskIcon"
                    [taskId]="row.taskId"
                    [projectId]="cbProject()?._id || ''"
                    (iconChange)="onTaskIconChange(row.taskId, $event)"
                  />
                  <span class="column-item-text">{{ row.taskName }}</span>
                }
                <img src="assets/img/icons/challenge-builder/task-cap.svg" alt="Task Cap" class="task-cap" />
              </div>
            }
          </div>
        </div>

        <div class="column-divider"></div>

        <!-- Metrics Column -->
        <div class="section-column">
          <div class="section-header">
            <div class="section-header-content">
              <img src="assets/img/icons/challenge-builder/metrics.png" alt="Metrics" class="section-icon" />
              <div class="section-header-text">
                <div class="section-title">Metrics</div>
                <div class="section-description">The fields and inputs to track your results as you go.</div>
              </div>
            </div>
          </div>
          <div class="column-list metrics-list">
            @for (row of taskMetricRows(); track $index) {
              <div class="column-item metric-item">
                <span class="metric-name">{{ row.metricName }}</span>
                <div class="metric-display">
                  @switch (row.metricType) {
                    @case ('boolean') {
                      <div class="metric-boolean">
                        <span class="bool-option">yes</span>
                        <div class="bool-divider"></div>
                        <span class="bool-option active">no</span>
                      </div>
                    }
                    @case ('numeric') {
                      <div class="metric-numeric">
                        <div class="numeric-value-box">
                          <span class="numeric-value">{{ row.targetValue ?? '—' }}</span>
                        </div>
                        <span class="numeric-unit">{{ row.metricTypeOption }}</span>
                      </div>
                    }
                    @case ('percent') {
                      <div class="metric-numeric">
                        <div class="numeric-value-box">
                          <span class="numeric-value">{{ row.targetValue ?? '—' }}</span>
                        </div>
                        <span class="numeric-unit">%</span>
                      </div>
                    }
                    @case ('duration') {
                      <div class="metric-numeric">
                        <div class="numeric-value-box">
                          <span class="numeric-value">{{ row.metricTypeOption }}</span>
                        </div>
                      </div>
                    }
                  }
                </div>
                <img src="assets/img/icons/challenge-builder/task-cap.svg" alt="Task Cap" class="task-cap" />
              </div>
            }
          </div>
        </div>

        <div class="column-divider"></div>

        <!-- Targets Column -->
        <div class="section-column">
          <div class="section-header">
            <div class="section-header-content">
              <img src="assets/img/icons/challenge-builder/target.png" alt="Targets" class="section-icon" />
              <div class="section-header-text">
                <div class="section-title">Targets</div>
                <div class="section-description">Your target values for each trackable metric.</div>
              </div>
            </div>
          </div>
          <div class="column-list targets-list">
            @for (row of taskMetricRows(); track $index) {
              <div class="column-item target-item">
                <span class="target-text">{{ row.targetSentence }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Schedule Section -->
  <div class="section-card schedule-section">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/schedule.png" alt="Schedule" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Schedule</div>
          <div class="section-description">The opportunities to record your activity throughout the cycle.</div>
        </div>
      </div>
      <cb-edit-button label="Edit Schedule" (buttonClick)="onEditSchedule()" />
    </div>
    <div class="schedule-scroll-container oph-scroll-bar">
      <div class="schedule-days">
        @for (day of daySchedules(); track day.dayLabel) {
          <div class="schedule-day">
            <div class="day-label">{{ day.dayLabel }}</div>
            <div class="day-tasks">
              @for (task of day.tasks; track task.taskName) {
                <div class="task-schedule">
                  <span class="task-name">{{ task.taskName }}</span>
                  <cb-schedule-chip [type]="task.scheduleType" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="scroll-fade"></div>
  </div>

  <!-- Salvages Section -->
  <div class="section-card">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/salvages.png" alt="Salvages" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Salvages</div>
          <div class="section-description">These tasks are opportunities to save a failing target.</div>
        </div>
      </div>
      @if (cbProject()?.challengeBuilder?.salvages?.length) {
        <cb-edit-button label="Add Task" (buttonClick)="openSalvageDialog()" />
      }
    </div>
    @if (cbProject()?.challengeBuilder?.salvages?.length) {
      <div class="section-content">
        <div class="section-list">
          @for (salvage of cbProject()?.challengeBuilder?.salvages; track salvage._id || $index) {
            <div class="section-item with-menu">
              <span>{{ salvage.name }}</span>
              <list-view-menu [options]="itemMenuOptions" (action)="onSalvageMenu($event, salvage)" />
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="section-content centered">
        <cb-edit-button label="Add Task" size="large" (buttonClick)="openSalvageDialog()" />
      </div>
    }
  </div>

  <!-- Rewards Section -->
  <div class="section-card">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/rewards.png" alt="Rewards" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Rewards</div>
          <div class="section-description">Treat yourself to a reward for hitting certain targets.</div>
        </div>
      </div>
      @if (cbProject()?.challengeBuilder?.rewards?.length) {
        <cb-edit-button label="Add Reward" (buttonClick)="onAddReward()" />
      }
    </div>
    @if (cbProject()?.challengeBuilder?.rewards?.length) {
      <div class="section-content">
        <div class="rewards-list">
          @for (reward of cbProject()?.challengeBuilder?.rewards; track reward._id || $index) {
            <div class="reward-item">
              <span class="reward-title">{{ reward.name }}</span>
              <div class="reward-cost">
                <span class="cost-value">{{ reward.rewardCost }}</span>
                <mat-icon svgIcon="coin-golden" class="coin-icon"></mat-icon>
              </div>
              <list-view-menu [options]="itemMenuOptions" (action)="onRewardMenu($event, reward)" />
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="section-content centered">
        <cb-edit-button label="Add Reward" size="large" (buttonClick)="onAddReward()" />
      </div>
    }
  </div>

  <!-- Alerts Section -->
  <div class="section-card">
    <div class="section-header">
      <div class="section-header-content">
        <img src="assets/img/icons/challenge-builder/alerts.png" alt="Alerts" class="section-icon" />
        <div class="section-header-text">
          <div class="section-title">Alerts</div>
          <div class="section-description">Set push notifications to motivate you.</div>
        </div>
      </div>
      @if (cbProject()?.challengeBuilder?.alerts?.length) {
        <cb-edit-button label="Add Alert" (buttonClick)="onAddAlert()" />
      }
    </div>
    @if (cbProject()?.challengeBuilder?.alerts?.length) {
      <div class="section-content">
        <div class="alerts-list">
          @for (alert of cbProject()?.challengeBuilder?.alerts; track alert._id || $index) {
            <div class="alert-item">
              <div class="alert-text">
                <span class="alert-time">{{ formatAlertTime(alert.time) }}</span>
                <span class="alert-message">{{ alert.message }}</span>
              </div>
              <oph-slide-toggle [checked]="alert.active" (toggle)="onToggleAlert(alert, $event)" />
              <list-view-menu [options]="itemMenuOptions" (action)="onAlertMenu($event, alert)" />
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="section-content centered">
        <cb-edit-button label="Add Alert" size="large" (buttonClick)="onAddAlert()" />
      </div>
    }
  </div>
</div>
